import { StaticSymbolsCommand } from "slotworks/commands/symbols/static-symbols-command";
import BetMenuFreespinsMediator from "slotworks/mediators/bet-menu-freespins-mediator";
import SmartButton from "slotworks/smart-button/smart-button";
import State from "slotworks/state-machine/states/state";
import Timer from "slotworks/utils/timer";
import Regulation from "slotworks/integration/revolver/regulations/regulation";
import GameState from "slotworks/model/game-state";

export default class FreespinIdle extends State {

    public static WAIT: number = 0;

    private waitTimer: number;

    public onEnter() {

        SmartButton.refresh();

        new BetMenuFreespinsMediator().start().execute();
        Regulation.updateNetPosition(GameState.getNetPosition());
        
        if (FreespinIdle.WAIT > 0) {
            this.waitTimer = Timer.setTimeout(() => this.complete(), FreespinIdle.WAIT);
        } else {
            this.complete();
        }
    }

    public onSkip() {
        Timer.clearTimeout(this.waitTimer);

        this.skip();
    }

    public onExit() {
        StaticSymbolsCommand().execute();

        super.onExit();
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/states/freespin-idle.ts